import {useEffect, useRef, useState} from 'react';
import {Alert, Box, Button, createStyles, Group, Modal} from '@mantine/core';
import {IconCheck, IconInfoCircle, IconTrash} from '@tabler/icons-react';
import SignatureCanvas from 'react-signature-canvas'
import {SIGNATURE_PEN_COLOR} from '../../config';

type PropsType = {
  show: boolean;
  onSigned?: (signature: string) => void;
  onClose?: () => void;
}

const useStyles = createStyles(theme => ({
  signature: {
    border: `1px solid ${theme.colors.gray[3]}`
  }
}));

const BLANK_SIGNATURE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZUAAADICAYAAAAgPHymAAAAAXNSR0IArs4c6QAABzxJREFUeF7t1TENAAAMw7CVP+mRyOkB6GFNys4RIECAAIFIYNGOGQIECBAgcKLiCQgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgICo+AECBAgQyAREJaM0RIAAAQKi4gcIECBAIBMQlYzSEAECBAiIih8gQIAAgUxAVDJKQwQIECAgKn6AAAECBDIBUckoDREgQICAqPgBAgQIEMgERCWjNESAAAECouIHCBAgQCATEJWM0hABAgQIiIofIECAAIFMQFQySkMECBAgICp+gAABAgQyAVHJKA0RIECAgKj4AQIECBDIBEQlozREgAABAqLiBwgQIEAgExCVjNIQAQIECIiKHyBAgACBTEBUMkpDBAgQICAqfoAAAQIEMgFRySgNESBAgMADOaYAyVl28aAAAAAASUVORK5CYII='

const SignatureModal = ({show, onSigned, onClose}: PropsType) => {
  const {classes} = useStyles();
  const [opened, setOpened] = useState(show);
  let signatureCanvasRef = useRef<any>({});

  useEffect(() => {
    setOpened(show);
  }, [show]);

  const handleClose = () => {
    setOpened(false);
    onClose && onClose();
  }

  const clearCanvas = () => {
    signatureCanvasRef.current.clear();
  }

  const handleSigned = () => {
    let signature = signatureCanvasRef.current.toDataURL('image/png');
    if (signature === BLANK_SIGNATURE) {
      signature = '';
    }

    onSigned && onSigned(signature);
    handleClose();
  }

  return (
    <Modal title="İmzala"
           centered
           opened={opened}
           onClose={handleClose}>
      <Alert icon={<IconInfoCircle size="1rem" />} color="gray" mb="md">
        Lütfen çerçeve içindeki alana imzanızı atınız.
      </Alert>
      <Box mb="md">
        <SignatureCanvas ref={signatureCanvasRef}
                         penColor={SIGNATURE_PEN_COLOR}
                         canvasProps={{width: 405, height: 200, className: classes.signature}}/>
      </Box>
      <Group position="apart">
        <Button leftIcon={<IconCheck size={14}/>} onClick={handleSigned}>Tamam</Button>
        <Button leftIcon={<IconTrash size={14}/>}
                color="red"
                onClick={clearCanvas}>Temizle</Button>
      </Group>
    </Modal>
  )
}

export default SignatureModal;
